import { api } from "@/builders/axios";
import { BookDemoForm, ContactForm } from "@/builders/types/contact-fom";

type Params = {
  page?: number;
  department?: number;
  course?: number;
};

const post = function (data: ContactForm) {
  return api.post("contact-us", data);
};
const demo = function (data: BookDemoForm) {
  return api.post("contact-us/book-demo", data);
};

export const contact_us = {
  post,
  demo,
};

